/* eslint-disable indent */
const weightCal = (weight) => {
  let res = 0;
  if (weight <= 50) {
    res = 50;
  } else if (weight > 50 && weight <= 100) {
    res = 100;
  } else if (weight > 100 && weight <= 250) {
    res = 250;
  } else if (weight > 250 && weight <= 500) {
    res = 500;
  } else if (weight > 500 && weight <= 750) {
    res = 750;
  } else if (weight > 750 && weight <= 1000) {
    res = 1000;
  }
  return res;
};

export const priceCal = (modename, docType, way, rateTYpe, weight) => {
  // let calResult = "";
  // let weg = weightCal(weight);
  // const doc = modename.docs
  //   .filter((ele) => ele.docType === docType)[0]
  //   .transports.filter((tr) => tr.mode === way)[0];

  // console.log(doc);

  // if (docType == "DOX") {
  //   calResult = doc.rates.find((e) => e.rateMode === weg + " Gms").rateTypes[
  //     rateTYpe
  //   ];
  // } else {
  //   calResult = doc.rates.find(
  //     (e) => e.rateMode.split(" ").filter(Number) == 1000
  //   ).rateTypes[rateTYpe];
  //   console.log("entered");
  // }
  // return calResult;

  // let temp1 = [];/
  let calResult = "";
  let weg = weightCal(weight);
  // console.log(weg,"weight")
  const doc = modename?.docs
    ?.filter((ele) => ele?.docType === docType)[0]
    ?.transports?.filter((tr) => tr?.mode === way)[0];

  if (docType == "DOX") {
    calResult = doc.rates.find((e) => e.rateMode === weg + " Gms").rateTypes[
      rateTYpe
    ];
  } else {
    // calResult = doc.rates.find(
    //   (e) => e.rateMode.split(" ").filter(Number) == 1000
    // ).rateTypes[rateTYpe];

    calResult = modename.docs[1].transports
      .filter((tr) => tr.mode === way)[0]
      .rates.find((e) => e.rateMode.split(" ").filter(Number) == 1000)
      .rateTypes[rateTYpe];
  }
  return calResult;
};
